import React from 'react'
import ModalFormUI from '../../../../widgets/form/ModalFormUI'

const MasterTemplateDownloadModalUI = ({ context, successMsg, errorList, setErrorList,
  // modes
  downloadMode, submitted,
  // event handlers
  onSubmit, onCancelClick,
  //
  onSelectLoanSpecificTerm, selectedLoanSpecificTerm,
  onSelectGuaranteeTerm, selectedGuaranteeTerm,
  onSelectEscrowTerm, selectedEscrowTerm,
  onSelectSpecialTerm, selectedSpecialTerm,
}) =>
  <ModalFormUI
    context={context}
    titleLabel='View template'
    buttonLabel='Download'
    cancelLabel='Cancel'
    isOpen={downloadMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <span className='g_m_left_100'><b>Select loan-specific term</b></span>
    <div className='g_m_top_100 g_m_bottom_100 g_flex_h g_flex_left'>
      <span className='g_m_left_100'>
        <input
          type='radio'
          name='options'
          value='nbfc'
          onChange={onSelectLoanSpecificTerm}
          defaultChecked={selectedLoanSpecificTerm === 'nbfc'}
        />
        Nbfc
      </span>
      <span className='g_m_left_100'>
        <input
          type='radio'
          name='options'
          value='po'
          onChange={onSelectLoanSpecificTerm}
          defaultChecked={selectedLoanSpecificTerm === 'po'}
        />
        Po
      </span>
      <span className='g_m_left_100'>
        <input
          type='radio'
          name='options'
          value='ppa'
          onChange={onSelectLoanSpecificTerm}
          defaultChecked={selectedLoanSpecificTerm === 'ppa'}
        />
        Ppa
      </span>
      <span className='g_m_left_100'>
        <input
          type='radio'
          name='options'
          value='ev'
          onChange={onSelectLoanSpecificTerm}
          defaultChecked={selectedLoanSpecificTerm === 'ev'}
        />
        Ev
      </span>
    </div>

    <span className='g_m_left_100'><b>Select pledge/NDU term</b></span>
    <div className='g_m_top_100 g_m_bottom_100 g_flex_h g_flex_left'>
      <span className='g_m_left_100'>
        <input
          type='radio'
          name='options2'
          value='pledge'
          onChange={onSelectGuaranteeTerm}
          defaultChecked={selectedGuaranteeTerm === 'pledge'}
        />
        Pledge
      </span>
      <span className='g_m_left_100'>
        <input
          type='radio'
          name='options2'
          value='ndu'
          onChange={onSelectGuaranteeTerm}
          defaultChecked={selectedGuaranteeTerm === 'ndu'}
        />
        Ndu
      </span>
    </div>

    <span className='g_m_left_100'><b>Select escrow term</b></span>
    <div className='g_m_top_100 g_m_bottom_100 g_flex_h g_flex_left'>
      <span className='g_m_left_100'>
        <input
          type='radio'
          name='options3'
          value='true'
          onChange={onSelectEscrowTerm}
          defaultChecked={selectedEscrowTerm === 'true'}
        />
        Escrow
      </span>
      <span className='g_m_left_100'>
        <input
          type='radio'
          name='options3'
          value='false'
          onChange={onSelectEscrowTerm}
          defaultChecked={selectedEscrowTerm === 'false'}
        />
        No escrow
      </span>
    </div>

    <span className='g_m_left_100'><b>Select special term</b></span>
    <div className='g_m_top_100 g_flex_h g_flex_left'>
      <span className='g_m_left_100'>
        <input
          type='radio'
          name='options4'
          value='true'
          onChange={onSelectSpecialTerm}
          defaultChecked={selectedSpecialTerm === 'true'}
        />
        Special terms
      </span>
      <span className='g_m_left_100'>
        <input
          type='radio'
          name='options4'
          value='false'
          onChange={onSelectSpecialTerm}
          defaultChecked={selectedSpecialTerm === 'false'}
        />
        No special terms
      </span>
    </div>
  </ModalFormUI>

export default MasterTemplateDownloadModalUI
